import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MobileReservationService } from '@rocksoft/inroom-sdk';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  MobileReservationActionTypes,
  MobileReservationApiMobileReservationsLoaded,
  MobileReservationApiMobileReservationsLoadedError,
  MobileReservationApiMobileReservationUpdated,
  MobileReservationApiMobileReservationUpdatedError,
  MobileReservationGuestModalConfirmed,
  MobileReservationResolverMobileReservationsRequested,
  MobileReservationsActionUnion,
} from './mobilereservation.actions';

@Injectable()
export class MobileReservationEffects {
  private readonly actions$ = inject<Actions<MobileReservationsActionUnion>>(Actions);
  private readonly mobileReservationService = inject(MobileReservationService);

  resolveMobileReservationEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MobileReservationActionTypes.MOBILE_RESERVATION_RESOLVER_MOBILE_RESERVATIONS_REQUESTED),
      mergeMap((action: MobileReservationResolverMobileReservationsRequested) =>
        this.mobileReservationService
          .lookupByLocation({ hotelCode: action.payload.hotelCode, unitCode: action.payload.unitCode })
          .pipe(
            map(
              (result) => new MobileReservationApiMobileReservationsLoaded({ mobileReservations: result.Data ?? [] })
            ),
            catchError((error) => of(new MobileReservationApiMobileReservationsLoadedError({ error })))
          )
      )
    );
  });

  saveMobileReservationEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MobileReservationActionTypes.MOBILE_RESERVATION_GUEST_MODAL_CONFIRMED),
      mergeMap((action: MobileReservationGuestModalConfirmed) =>
        this.mobileReservationService.putOverview({ reservationApiModel: action.payload.mobileReservation }).pipe(
          map(
            () =>
              new MobileReservationApiMobileReservationUpdated({ mobileReservation: action.payload.mobileReservation })
          ),
          catchError((error) =>
            of(
              new MobileReservationApiMobileReservationUpdatedError({
                originalMobileReservation: action.payload.mobileReservation,
                mobileReservation: action.payload.mobileReservation,
                error: error,
              })
            )
          )
        )
      )
    );
  });
}
